import { useContext, useState } from 'react';
import dayjs from 'dayjs';
import { SolicitudCoberturaContext } from '../context';
import { getSolicitudCoberturaIniciadosAutorizados } from '../../../../../../services/Busquedas/SolicitudCobertura';

export const useSolicitudCoberturaIniciadoAutorizadoData = ({
  idDivision,
  idTipoCobertura,
  fechaDesde,
  fechaHasta,
}) => {
  const [state, setState] = useState({
    isLoading: false,
    hasError: false,
    errorMessage: null,
    successMessage: null,
  });

  const { setSolicitudCoberturaAnualList, setSolicitudCoberturaMensualList } =
    useContext(SolicitudCoberturaContext);

  // Últimos 30 días
  const currentMonthDateRange = {
    fechaDesde: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
    fechaHasta: dayjs().format('YYYY-MM-DD'),
  };

  const currentYearDateRange = {
    fechaDesde: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaHasta: dayjs().endOf('year').format('YYYY-MM-DD'),
  };

  /**
   * Recibe como parametro una función helper y controla su response
   * @param {function} callback
   * @returns response: Object
   */
  const apiCall = async (callback, data) => {
    setState({ ...state, isLoading: true });
    const response = await callback(data);

    setState({
      ...state,
      isLoading: false,
    });

    return response;
  };

  /**
   * Obtiene una lista de solicitudes de cobertura del año actual
   */
  const getSolicitudCoberturaAnualList = async () => {
    const list = await apiCall(getSolicitudCoberturaIniciadosAutorizados, {
      fechaDesde: currentYearDateRange.fechaDesde,
      fechaHasta: currentYearDateRange.fechaHasta,
      idDivision,
      idTipoCobertura,
    });

    await setSolicitudCoberturaAnualList({ data: list, date: currentYearDateRange.fechaDesde });
  };

  /**
   * Obtiene una lista de solicitudes de cobertura del mes actual
   */
  const getSolicitudCoberturaMensualList = async () => {
    const list = await apiCall(getSolicitudCoberturaIniciadosAutorizados, {
      fechaDesde: currentMonthDateRange.fechaDesde,
      fechaHasta: currentMonthDateRange.fechaHasta,
      idDivision,
      idTipoCobertura,
    });

    await setSolicitudCoberturaMensualList({ data: list, date: currentMonthDateRange.fechaDesde });
    setState({ ...state, isLoading: false });
  };

  return {
    ...state,
    fechaAnioActual: currentYearDateRange.fechaDesde,
    fechaMesActual: currentMonthDateRange.fechaDesde,
    getSolicitudCoberturaAnualList,
    getSolicitudCoberturaMensualList,
  };
};
